import React from "react";
import { useNavigate } from "react-router-dom";

import { getAuthToken } from "../../lib/api/tokenStore";
import { formatAmount } from "../accessories/accessoryMoney";
import useCart from "./useCart";
import SupplierCartCard from "./components/SupplierCartCard";
import EmptyCartView from "./components/EmptyCartView";
import CartPageSkeleton from "./components/CartSkeletons";
import CartSummaryPanel from "./components/CartSummaryPanel";
import useDeliverySelection from "../checkout/useDeliverySelection";
import useDeliveryAddress from "../checkout/useDeliveryAddress";
import DeliveryAddressCard from "../checkout/components/DeliveryAddressCard";
import CheckoutSteps from "../checkout/components/CheckoutSteps";
import FlowStickyHeader from "../checkout/components/FlowStickyHeader";
import FlowPageHead from "../checkout/components/FlowPageHead";

import "../checkout/styles.css";
import "./styles.css";

const CartRoute = () => {
  const navigate = useNavigate();
  const cart = useCart({ enabled: Boolean(getAuthToken()) });
  const delivery = useDeliverySelection(cart.summary.carts);
  const addressState = useDeliveryAddress();

  const handleChangeQuantity = (line, quantity) => cart.setQuantity(line, quantity);
  const handleRemoveLine = (line) => cart.removeLine(line);
  const handleRemoveCart = (supplierCart) => cart.removeSupplierCart(supplierCart);

  const { summary } = cart;
  const canCheckout = !summary.isEmpty && !summary.hasOutOfStock;

  return (
    <div className="sy-flow sy-cart full-bleed">
      <div className="sy-flow-shell">
        <FlowStickyHeader>
          <FlowPageHead title="My cart" />

          {!cart.isLoading && !summary.isEmpty && <CheckoutSteps current="cart" />}
        </FlowStickyHeader>

        {cart.isLoading ? (
          <CartPageSkeleton />
        ) : summary.isEmpty ? (
          <EmptyCartView />
        ) : (
          <>
            <div className="sy-flow-grid">
              <div className="sy-flow-main">
                <DeliveryAddressCard
                  summary={summary}
                  delivery={delivery}
                  addressState={addressState}
                />

                {summary.carts.map((supplierCart) => (
                  <SupplierCartCard
                    key={supplierCart.cartId}
                    cart={supplierCart}
                    onChangeQuantity={handleChangeQuantity}
                    onRemoveLine={handleRemoveLine}
                    onRemoveCart={handleRemoveCart}
                  />
                ))}
              </div>

              <div className="sy-flow-rail">
                <CartSummaryPanel summary={summary} />
              </div>
            </div>

            <div className="sy-cart-bar">
              <span className="sy-cart-bar-total">
                <span>Subtotal</span>
                <b>{formatAmount(summary.total, summary.currency)}</b>
              </span>

              <button
                type="button"
                className="sy-flow-btn sy-flow-btn-primary"
                disabled={!canCheckout}
                onClick={() => navigate("/checkout")}
              >
                Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartRoute;
